export const RUN_TYPE_OPTIONS = [
  { value: 'all', label: 'All types' },
  { value: 'PersonaGenerationWorkflow', label: 'Persona' },
  { value: 'ContentGenerationWorkflow', label: 'Content' },
  { value: 'AssemblyWorkflow', label: 'Assembly' },
];

export const RUN_STATUS_OPTIONS = [
  { value: 'all', label: 'All statuses' },
  { value: 'RUNNING', label: 'Running' },
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'FAILED', label: 'Failed' },
  { value: 'CANCELED', label: 'Cancelled' },
  { value: 'TIMED_OUT', label: 'Timed out' },
];

export const RUN_WINDOW_OPTIONS = [
  { value: 24, label: 'Last 24h' },
  { value: 24 * 7, label: 'Last 7d' },
  { value: 24 * 30, label: 'Last 30d' },
];

export const RUNS_LIST_LIMIT = 200;
export const RUNS_LIST_RUNNING_POLL_MS = 5_000;
export const RUNS_LIST_IDLE_POLL_MS = 15_000;

export const RUN_DETAIL_RUNNING_POLL_MS = 3_000;
export const RUN_DETAIL_IDLE_POLL_MS = 15_000;

export const TEMPORAL_UI_BASE =
  import.meta.env.VITE_TEMPORAL_UI_BASE ?? 'http://localhost:8080';
export const TEMPORAL_NAMESPACE =
  import.meta.env.VITE_TEMPORAL_NAMESPACE ?? 'ghost';
